import { render, staticRenderFns } from "./AddStatusPage.vue?vue&type=template&id=338ba206&scoped=true"
import script from "./AddStatusPage.vue?vue&type=script&lang=js"
export * from "./AddStatusPage.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./AddStatusPage.vue?vue&type=style&index=1&id=338ba206&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338ba206",
  null
  
)

export default component.exports